var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLife(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_112_1079)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3166 4.09262C23.4204 4.09262 20.4384 3.11615 18.6229 2.29698C16.6493 1.40649 15.5851 0.502868 15.5762 0.495302L15.0013 0L14.4255 0.493836C14.415 0.502868 13.3507 1.40655 11.3771 2.29698C9.56168 3.11615 6.57967 4.09262 2.68347 4.09262H1.80371V16.169L15 29.9999L28.1964 16.1812V4.09262H27.3166ZM24.6773 12.3075C24.6773 13.6718 24.1472 14.9545 23.1844 15.9206L15 24.4225L6.81568 15.9205C5.85281 14.9545 5.32273 13.6717 5.32273 12.3075V11.8501C5.32273 9.02793 7.61877 6.73183 10.441 6.73183C11.7076 6.73183 12.9236 7.19845 13.865 8.04571L14.9681 9.03854L15.7757 8.23093C16.7425 7.2642 18.0278 6.73177 19.3949 6.73177H19.559C22.3812 6.73177 24.6773 9.02781 24.6773 11.8501V12.3075H24.6773Z",
    fill: "#396AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5588 8.49139H19.3948C18.4977 8.49139 17.6542 8.84077 17.0197 9.47513L15.0317 11.4631L12.6878 9.35355C12.0699 8.79755 11.272 8.49133 10.4408 8.49133C8.58876 8.49133 7.08203 9.99806 7.08203 11.8501V12.3075C7.08203 13.2047 7.43141 14.0482 8.06577 14.6825L8.0775 14.6944L14.9998 21.8854L21.9338 14.6825C22.5682 14.0481 22.9176 13.2046 22.9176 12.3074V11.8501C22.9176 9.99818 21.4108 8.49139 19.5588 8.49139ZM17.6391 16.4092H15.8796V18.1687H14.1201V16.4092H12.3606V14.6497H14.1201V12.8902H15.8796V14.6497H17.6391V16.4092Z",
    fill: "#396AFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_112_1079"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLife);
export default __webpack_public_path__ + "static/media/life.4494f2f213da90945682264efbaa0b87.svg";
export { ForwardRef as ReactComponent };